import { combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import dashboardSlice from "./reducers/dashboardSlice";
import notificationSlice from "./reducers/notificationSlice"; 
import  profileSlice  from "./reducers/profileSlice";
import  reportSlice  from "./reducers/reportSlice";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  blacklist: ["register", "History"],
};

const persistingReducer = combineReducers({  
  Dashboard: dashboardSlice,
  notification: notificationSlice, 
  report:reportSlice,
  profile:profileSlice, 
});

const persistedReducer = persistReducer(persistConfig, persistingReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;